import React from "react";

/**
 * Reusable table primitives (shadcn-style structure) for maintainability.
 * Can be replaced with shadcn Table later without changing page structure.
 */

const Table = ({ className = "", ...props }) => (
  <div className="overflow-x-auto w-full">
    <table
      className={`w-full caption-bottom text-sm border-collapse ${className}`}
      {...props}
    />
  </div>
);

const TableHeader = ({ ...props }) => <thead {...props} />;

const TableBody = ({ ...props }) => <tbody {...props} />;

const TableRow = ({ className = "", ...props }) => (
  <tr
    className={`border-b border-gray-200 transition-colors hover:bg-gray-50/50 ${className}`}
    {...props}
  />
);

const TableHead = ({ className = "", ...props }) => (
  <th
    className={`h-10 px-4 text-left align-middle font-semibold text-gray-600 text-xs uppercase tracking-wider bg-gray-100 border-b border-gray-200 ${className}`}
    {...props}
  />
);

const TableCell = ({ className = "", ...props }) => (
  <td
    className={`p-4 align-middle text-gray-700 text-sm border-t border-gray-100 ${className}`}
    {...props}
  />
);

export { Table, TableHeader, TableBody, TableRow, TableHead, TableCell };
